var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfficer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.89,
    height: 22.531,
    viewBox: "0 0 18.89 22.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "officer_1_",
    "data-name": "officer (1)",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73716",
    "data-name": "Group 73716",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90717",
    "data-name": "Path 90717",
    d: "M104.147,308.744a.347.347,0,0,1-.347-.347v-4.15a.347.347,0,1,1,.694,0v4.15A.355.355,0,0,1,104.147,308.744Z",
    transform: "translate(-100.373 -286.725)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90718",
    "data-name": "Path 90718",
    d: "M290.347,308.744A.347.347,0,0,1,290,308.4v-4.15a.347.347,0,1,1,.694,0v4.15A.347.347,0,0,1,290.347,308.744Z",
    transform: "translate(-275.438 -286.725)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73715",
    "data-name": "Group 73715"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90723",
    "data-name": "Path 90723",
    d: "M129.614,22.3a.372.372,0,0,1-.257-.108.922.922,0,0,1-.161-.269,6.72,6.72,0,0,0-.8-1.262,4.456,4.456,0,0,0-.323-.377,2.508,2.508,0,0,0-.317-.263,1.631,1.631,0,0,1-.407.353,2.053,2.053,0,0,1-1.22.257H126.1c-.012,0-1.082-.024-2.225.054l-.054.006a2.723,2.723,0,0,0-1.076.215c-.3.161-.472.484-.586,1.088a.39.39,0,0,1-.239.287.377.377,0,0,1-.425-.132,1.842,1.842,0,0,1-.275-.915v-.006a5.044,5.044,0,0,1,.024-1.692,3.732,3.732,0,0,1,.855-1.214,6.87,6.87,0,0,1,3.068-1.459,7.073,7.073,0,0,1,1.842-.144,5.819,5.819,0,0,1,1.041.155,1.467,1.467,0,0,1,.867.544,1.987,1.987,0,0,1,.209.4,1.01,1.01,0,0,0,.173.311,2.556,2.556,0,0,0,.329.269,2.884,2.884,0,0,1,.407.329,2.615,2.615,0,0,1,.742,1.429,2.1,2.1,0,0,1-.377,1.3c-.024.042-.138.215-.251.383-.239.347-.329.46-.508.478-.006-.018-.018-.018-.03-.018Zm-1.938-3.062a.72.72,0,0,1,.407.167l.012.006a3.344,3.344,0,0,1,.46.377,3.93,3.93,0,0,1,.383.443,7.966,7.966,0,0,1,.724,1.088c.072-.108.138-.209.161-.245a1.5,1.5,0,0,0,.281-.867,1.986,1.986,0,0,0-.544-1.017,2.347,2.347,0,0,0-.317-.251,2.616,2.616,0,0,1-.437-.359,1.664,1.664,0,0,1-.3-.514,1.255,1.255,0,0,0-.138-.269.872.872,0,0,0-.478-.275,5.149,5.149,0,0,0-.921-.132,5.923,5.923,0,0,0-1.651.132,6.1,6.1,0,0,0-2.733,1.28,3.064,3.064,0,0,0-.7.987,3.872,3.872,0,0,0-.006,1,1.548,1.548,0,0,1,.55-.5A3.263,3.263,0,0,1,123.777,20l.054-.006c1.178-.084,2.243-.06,2.284-.054h.024a1.449,1.449,0,0,0,.837-.149,1.019,1.019,0,0,0,.347-.365.39.39,0,0,1,.251-.179A.652.652,0,0,1,127.676,19.236Zm.251.538Z",
    transform: "translate(-116.696 -16.707)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90724",
    "data-name": "Path 90724",
    d: "M122.079,105.394a3.791,3.791,0,0,1-.813-.09,3.967,3.967,0,0,1-1.621-.807,4.135,4.135,0,0,1-1.25-1.782,4.029,4.029,0,0,1-.185-.724,1.875,1.875,0,0,1-.64-.472,1.976,1.976,0,0,1-.466-.909,1.854,1.854,0,0,1,.634-1.83.343.343,0,1,1,.449.52,1.154,1.154,0,0,0-.413,1.166,1.284,1.284,0,0,0,.837.945.34.34,0,0,1,.245.287,4.964,4.964,0,0,0,.185.8,3.506,3.506,0,0,0,1.041,1.483,3.275,3.275,0,0,0,1.334.664,2.946,2.946,0,0,0,1.31,0,2.915,2.915,0,0,0,1.011-.46,3.4,3.4,0,0,0,.67-.616,4.4,4.4,0,0,0,.879-1.914.344.344,0,0,1,.281-.269c.359-.06.724-.628.765-1.19a.717.717,0,0,0-.454-.819.342.342,0,0,1,.209-.652,1.377,1.377,0,0,1,.927,1.525,2.467,2.467,0,0,1-.395,1.142,1.593,1.593,0,0,1-.712.61,4.83,4.83,0,0,1-.981,2.009,4.3,4.3,0,0,1-.807.742,3.62,3.62,0,0,1-1.244.568,4.4,4.4,0,0,1-.8.078Z",
    transform: "translate(-112.839 -93.793)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90725",
    "data-name": "Path 90725",
    d: "M158.643,191.883a.368.368,0,0,1-.155-.036.342.342,0,0,1-.155-.46,2.9,2.9,0,0,0,.311-1.172,1.205,1.205,0,0,0-.06-.437c-.012-.042-.024-.084-.036-.132a.343.343,0,1,1,.664-.173.873.873,0,0,1,.03.12,1.919,1.919,0,0,1,.09.64,3.752,3.752,0,0,1-.383,1.459A.326.326,0,0,1,158.643,191.883Z",
    transform: "translate(-151.61 -178.9)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90726",
    "data-name": "Path 90726",
    d: "M224.163,193.191a.347.347,0,0,1-.3-.173,3.485,3.485,0,0,1-.472-1.609,1.919,1.919,0,0,1,.09-.64.14.14,0,0,0,.012-.048.345.345,0,1,1,.664.185.175.175,0,0,0-.012.054,1.2,1.2,0,0,0-.06.437,2.865,2.865,0,0,0,.389,1.286.337.337,0,0,1-.132.466A.431.431,0,0,1,224.163,193.191Z",
    transform: "translate(-212.813 -180.077)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90727",
    "data-name": "Path 90727",
    d: "M64.542,220.009h-17.7a.35.35,0,0,1-.347-.341,25.174,25.174,0,0,1,.682-6.423,5.3,5.3,0,0,1,.634-1.375,5.432,5.432,0,0,1,4.736-2.356.34.34,0,0,1,.221.1l2.847,2.673,3-2.679a.365.365,0,0,1,.215-.09,5.525,5.525,0,0,1,2.721.586,5.429,5.429,0,0,1,2.015,1.77,5.31,5.31,0,0,1,.634,1.375,25.148,25.148,0,0,1,.682,6.423A.345.345,0,0,1,64.542,220.009Zm-8.875-.694H64.2a24.151,24.151,0,0,0-.652-5.873,4.423,4.423,0,0,0-.55-1.2,4.681,4.681,0,0,0-1.752-1.537,4.886,4.886,0,0,0-2.26-.52l-3.146,2.8a.348.348,0,0,1-.466-.006L52.391,210.2a4.849,4.849,0,0,0-2.255.52,4.63,4.63,0,0,0-1.752,1.537,4.509,4.509,0,0,0-.55,1.2,24.183,24.183,0,0,0-.652,5.873Z",
    transform: "translate(-46.494 -197.978)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficer1);
export default __webpack_public_path__ + "static/media/officer (1).4ee848796e1cbc856f72059c010f9c96.svg";
export { ForwardRef as ReactComponent };